(function () {
  const FREE_VARIANT_ID = 46168174002411;
  const PROMO_CODES = ['FREESYRUP', 'BIRTHDAY'];
  const COOKIE_NAME = 'wellpaws_promo';
  const HIDDEN_FORM_ID = 'wellpaws-auto-add-form';
  const MIN_CART_TOTAL = 2000; // £20.00 in pence

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // On page load, detect promo from URL and set cookie
  const params = new URLSearchParams(window.location.search);
  const campaign = (params.get('utm_campaign') || '').toUpperCase();
  for (let i = 0; i < PROMO_CODES.length; i++) {
    if (campaign === PROMO_CODES[i]) {
      setCookie(COOKIE_NAME, PROMO_CODES[i], 30);
      break;
    }
  }

  function hasPromo() {
    return !!getCookie(COOKIE_NAME);
  }

  // Flag so our own auto-add doesn't recursively trigger itself
  let autoAddTriggered = false;

  function triggerAutoAdd() {
    const form = document.getElementById(HIDDEN_FORM_ID);
    if (!form) {
      console.error('[wellpaws promo] hidden auto-add form not found');
      return;
    }
    autoAddTriggered = true;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
    }
  }

  function handleCartUpdate(event) {
    if (!hasPromo()) return;
    if (!event || event.source !== 'product-form') return;

    const addedVariantId = parseInt(event.productVariantId, 10);

    // If this cartUpdate is the result of our own auto-add, ignore it.
    if (autoAddTriggered && addedVariantId === FREE_VARIANT_ID) {
      autoAddTriggered = false;
      return;
    }

    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // If a syrup line item already has a discount applied, the free gift
        // is already in the cart - don't add more.
        const hasDiscountedSyrup = cart.items.some(function (item) {
          return item.variant_id === FREE_VARIANT_ID && item.total_discount > 0;
        });
        if (hasDiscountedSyrup) return;

        // Cart must be at least £20 to qualify for the free syrup.
        if (cart.total_price < MIN_CART_TOTAL) return;

        const syrupItems = cart.items.filter(function (item) {
          return item.variant_id === FREE_VARIANT_ID;
        });
        const syrupQty = syrupItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        if (addedVariantId === FREE_VARIANT_ID) {
          // User manually added the syrup. If they have exactly 1, add another
          // so the discount gives them 1 paid + 1 free.
          if (syrupQty === 1) {
            setTimeout(triggerAutoAdd, 1000);
          }
        } else {
          // User added a different product. Ensure 1 syrup in cart.
          if (syrupQty === 0) {
            setTimeout(triggerAutoAdd, 1000);
          }
        }
      })
      .catch(function (e) { console.error('[wellpaws promo] cart fetch failed', e); });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
})();
